import React from 'react';
import PropTypes from 'prop-types';
import { BDataGrid } from '../common/dataGrid/BDataGrid';
import LoaderComponent from '../common/LoaderComponent';
import { columnMeta } from './PaymentHistoryHelper';
import ShowMoreLoaderComponent from '../common/ShowMoreLoaderComponent';
class PaymentHistoryListDesktop extends React.Component {
  constructor(props) {
    super(props);
    this.onCustomClick = this.onCustomClick.bind(this);
    this.customLoadingComponent = this.customLoadingComponent.bind(this);
    this.onSort = this.onSort.bind(this);
    this.state = {
      showChildrenIds: [],
    };
  }
  onCustomClick(rowData, clickType = 'VIEW', showChild = false) {
    if (clickType === 'VIEW') {
      this.props.onCustomClick(rowData);
    } else {
      let { showChildrenIds } = this.state;
      if (showChild) {
        showChildrenIds.push(rowData.id);
      } else {
        showChildrenIds = showChildrenIds.filter((id) => id !== rowData.id);
      }
      this.setState({
        showChildrenIds,
      });
    }
  }
  onSort(sort, sortAscending) {
    this.props.sortTransacations(sort, sortAscending);
  }
  customLoadingComponent() {
    if (!this.props.hasError) {
      return <LoaderComponent type="small" />;
    } else {
      return (
        <div className="text-center">
          <div className="errormessage">{this.props.error.message}</div>
          <button
            onClick={this.props.clickToReload}
            className="c-btn c-btn--default"
          >
            Retry
          </button>
        </div>
      );
    }
  }
  renderFooter() {
    return this.props.showMore
      ? this.renderShowMore()
      : this.renderFooterMessage();
  }
  renderFooterMessage() {
    return (
      <div className="manage-payment-history-footer">
        <p>{this.props.content.paymentHistoryFooterMsg}</p>
      </div>
    );
  }
  renderShowMore() {
    const { isFetchingMore } = this.props;
    return (
      <div className="manage-payment-history-footer">
        {isFetchingMore ? (
          <ShowMoreLoaderComponent />
        ) : (
          <button
            className="c-btn c-btn--default c-btn--lg"
            onClick={this.props.loadMorePaymentList}
          >
            {this.props.content.showMore}
          </button>
        )}
      </div>
    );
  }
  render() {
    return (
      <div>
        <div className="manage-payments-table-container manage-payments-table-container-medium">
          <BDataGrid
            results={this.props.paymentHistoryList}
            columns={[
              'createdDate',
              'fromAccountName',
              'toAccountName',
              'amount',
              'status',
              'option',
            ]}
            columnMetadata={columnMeta}
            useCustomPagerComponent={false}
            isFooterEnabled
            gridFooterCss=""
            onSort={this.onSort}
            rowClick={this.rowClick}
            initialSort="createdDate"
            content={this.props.content}
            rowExpander
            customClick={this.onCustomClick}
            showPager={false}
            externalIsLoading={this.props.isLoading || this.props.hasError}
            tableClassName="manage-payments-table manage-payments-table-medium"
            externalLoadingComponent={this.customLoadingComponent}
            showNoData
            noDataMessage={this.props.content.paymentHistoryNoDataMsg}
            showChildrenIds={this.state.showChildrenIds}
          />
        </div>
        {this.props.paymentHistoryList.length > 0 && this.renderFooter()}
      </div>
    );
  }
}
PaymentHistoryListDesktop.propTypes = {
  content: PropTypes.object,
  paymentHistoryList: PropTypes.array,
  sortTransacations: PropTypes.func,
  onCustomClick: PropTypes.func,
  clickToReload: PropTypes.func,
  isLoading: PropTypes.bool,
  showMore: PropTypes.bool,
  hasError: PropTypes.bool,
  isFetchingMore: PropTypes.bool,
  error: PropTypes.object,
  loadMorePaymentList: PropTypes.func,
};

PaymentHistoryListDesktop.defaultProps = {
  content: {},
  paymentHistoryList: [],
  isLoading: false,
  hasError: false,
  error: {
    message: 'Something went wrong',
  },
  showMore: true,
  isFetchingMore: false,
};
export default PaymentHistoryListDesktop;
